import React, {useRef, useState} from 'react';
import emailjs from '@emailjs/browser';
import Footer from "./footer";
import Header from "./header";

function Contact() {
    const form = useRef<HTMLFormElement | null>(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const sendEmail = (e: any) => {
        e.preventDefault();
        setMessage('');
        setLoading(true);
        emailjs.sendForm(
            process.env.REACT_APP_EMAIL_SERVICE_ID as string,
            process.env.REACT_APP_EMAIL_TEMPLATE_ID as string,
            e.target,
            process.env.REACT_APP_EMAIL_PUBLIC_KEY as string
        ).then(() => {
            setMessage('Your request was received. Expect a reply within 72 hours.');
            setLoading(false);
        }, () => {
            setMessage("Oops, we couldn't send your request. Please try again or email hello@unit326.com directly.");
            setLoading(false);
        });
    };

    return (
        <div className="min-h-screen flex flex-col">
            <Header />

            <section className="flex-1 container pt-28 pb-16 max-w-2xl mx-auto px-4">
                <h1 className="text-3xl font-bold text-[#2d4f37] mb-2">Data History or Deletion Request</h1>
                <p className="text-stone-500 mb-8">
                    Complete the form below to request a copy of your data or to have your data deleted from our systems.
                    We will respond within 72 hours.
                </p>

                <form ref={form} onSubmit={sendEmail} className="space-y-5">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                            <label htmlFor="user_name" className="block text-sm font-medium text-stone-700 mb-1">Your Name</label>
                            <input
                                type="text"
                                name="user_name"
                                id="user_name"
                                required
                                className="w-full border border-stone-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#4a7c59]"
                            />
                        </div>
                        <div>
                            <label htmlFor="user_email" className="block text-sm font-medium text-stone-700 mb-1">Your Email</label>
                            <input
                                type="email"
                                name="user_email"
                                id="user_email"
                                required
                                className="w-full border border-stone-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#4a7c59]"
                            />
                        </div>
                    </div>

                    <div>
                        <label htmlFor="company" className="block text-sm font-medium text-stone-700 mb-1">Request Type</label>
                        <select
                            name="company"
                            id="company"
                            className="w-full border border-stone-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#4a7c59]"
                        >
                            <option value="Account Deletion">Account Deletion</option>
                            <option value="Data History Request">Data History Request</option>
                            <option value="Data Deletion">Data Deletion</option>
                        </select>
                    </div>

                    <div>
                        <label htmlFor="message" className="block text-sm font-medium text-stone-700 mb-1">Message</label>
                        <textarea
                            name="message"
                            id="message"
                            required
                            rows={4}
                            className="w-full border border-stone-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#4a7c59]"
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        className="bg-[#4a7c59] text-white px-6 py-2 rounded-lg text-sm font-medium hover:bg-[#3d6649] transition-colors disabled:opacity-60"
                    >
                        {loading ? 'Sending...' : 'Send Request'}
                    </button>

                    {message && (
                        <p className={`text-sm mt-2 ${message.startsWith('Oops') ? 'text-red-600' : 'text-green-700'}`}>
                            {message}
                        </p>
                    )}
                </form>
            </section>

            <Footer />
        </div>
    );
}

export default Contact;
